import yup from '../../../../../utils/yup/yupInstance';
import { EnglishExamStatusEnum } from '../../utils';
export var englishTestSubScoreValidation = function (value, examType) {
    if (examType === 'TOEFL') {
        if (typeof value !== 'number')
            return false;
        if (Number(value) > 0 && Number(value) <= 30)
            return true;
        return false;
    }
    return undefined;
};
export var englishTestSubScoreValidationMessage = function (examType) {
    if (examType === 'TOEFL')
        return 'Enter value between 0 and 30';
    return undefined;
};
var optionSchema = yup.object().shape({
    label: yup.string(),
    value: yup.string()
});
export var eligibilityEnglishExamSchema = yup.object().shape({
    englishExamStatus: optionSchema.nullable(),
    englishExamType: optionSchema.nullable(),
    englishTotalScore: yup
        .number()
        .englishTestScore('englishExamType')
        .decimalPoints(2, 'Only 2 decimal points are allowed')
        .nullable(),
    listening: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN &&
                ((englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'IELTS' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'PTE' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'TOEFL');
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    reading: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN &&
                ((englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'IELTS' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'PTE' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'TOEFL');
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    writing: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN &&
                ((englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'IELTS' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'PTE' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'TOEFL');
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    speaking: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN &&
                ((englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'IELTS' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'PTE' || (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'TOEFL');
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    conversation: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN && (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'DUOLINGO';
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    literacy: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN && (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'DUOLINGO';
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    production: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN && (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'DUOLINGO';
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    comprehension: yup.number().when(['englishExamType', 'englishExamStatus'], {
        is: function (englishExamType, englishExamStatus) {
            return (englishExamStatus === null || englishExamStatus === void 0 ? void 0 : englishExamStatus.value) === EnglishExamStatusEnum.GIVEN && (englishExamType === null || englishExamType === void 0 ? void 0 : englishExamType.value) === 'DUOLINGO';
        },
        then: function () {
            return yup
                .number()
                .englishTestScore('englishExamType', englishTestSubScoreValidation, englishTestSubScoreValidationMessage)
                .decimalPoints(2, 'Only 2 decimal points are allowed')
                .nullable();
        },
        otherwise: function () { return yup.number().nullable(); }
    }),
    twelfthEnglishGradingScheme: optionSchema.nullable(),
    twelfthEnglishGrade: yup
        .string()
        .validGradeCheck('twelfthEnglishGrade', 'twelfthEnglishGradingScheme', true)
        .decimalPoints(2, 'Only 2 decimal points are allowed')
        .nullable(),
    twelfthGraduationYear: optionSchema.nullable(),
    twelfthBoardCode: optionSchema.nullable(),
    ugUniversityCode: optionSchema.nullable()
});
export var eligiblityAcademicSchema = yup.object().shape({
    student: optionSchema.nullable(),
    twelfthGradingScheme: optionSchema.nullable(),
    twelfthGrade: yup
        .string()
        .validGradeCheck('twelfthGrade', 'twelfthGradingScheme', true)
        .decimalPoints(2, 'Only 2 decimal points are allowed')
        .nullable(),
    ugGradingScheme: optionSchema.nullable(),
    ugBacklogs: yup.number().wholeNumber('Only whole numbers are allowed').nullable(),
    universityNaac: optionSchema.nullable(),
    ugGrade: yup
        .string()
        .validGradeCheck('ugGrade', 'ugGradingScheme', true)
        .decimalPoints(2, 'Only 2 decimal points are allowed')
        .nullable(),
    pgGrade: yup
        .string()
        .validGradeCheck('pgGrade', 'pgGradingScheme', true)
        .decimalPoints(2, 'Only 2 decimal points are allowed')
        .nullable(),
    pgGradingScheme: optionSchema.nullable()
    // twelfthEnglishGrade: yup
    //   .string()
    //   .validGradeCheck('twelfthEnglishGrade', 'twelfthGradingScheme', true)
    //   .decimalPoints(2, 'Only 2 decimal points are allowed')
    //   .nullable(),
    // twelfthGraduationYear: optionSchema.nullable(),
    // twelfthBoardCode: optionSchema.nullable(),
    // ugUniversityCode: optionSchema.nullable()
    // pgbacklogs: yup.number().nullable(),
    // greExamScore: yup
    //   .number()
    //   .test(``, function (value) {
    //     if (
    //       this.parent?.[`additionalExam`]?.value !== `GRE` ||
    //       isFalsy(value) ||
    //       Number.isNaN(Number(value))
    //     )
    //       return true;
    //     if (Number(value) < 0) {
    //       return this.createError({
    //         message: `Score should be between o to 340`,
    //       });
    //     } else if (Number(value) > 340) {
    //       return this.createError({
    //         message: `Score should be between o to 340`,
    //       });
    //     }
    //     return true;
    //   })
    //   .decimalPoints(2, `Only 2 decimal points are allowed`)
    //   .nullable(),
    // gmatExamScore: yup
    //   .number()
    //   .test(``, function (value) {
    //     if (
    //       this.parent?.[`additionalExam`]?.value !== `GMAT` ||
    //       isFalsy(value) ||
    //       Number.isNaN(Number(value))
    //     )
    //       return true;
    //     if (Number(value) < 200) {
    //       return this.createError({
    //         message: `Score should be between 200 to 800`,
    //       });
    //     } else if (Number(value) > 800) {
    //       return this.createError({
    //         message: `Score should be between 200 to 800`,
    //       });
    //     }
    //     return true;
    //   })
    //   .decimalPoints(2, `Only 2 decimal points are allowed`)
    //   .nullable(),
    // additionalExam: optionSchema.nullable(),
});
export var eligibilityTwelfthDetailsSchema = yup.object().shape({
    twelfthEnglishGrade: yup
        .string()
        .validGradeCheck('twelfthEnglishGrade', 'twelfthGradingScheme', true)
        .decimalPoints(2, 'Only 2 decimal points are allowed')
        .nullable(),
    twelfthGraduationYear: optionSchema.nullable(),
    twelfthBoardCode: optionSchema.nullable(),
    ugUniversityCode: optionSchema.nullable()
});
export var studentRegionSchema = yup.object().shape({
    studentCountryId: optionSchema.nullable(),
    studentStateId: optionSchema.nullable()
});
export var eligibilitySchema = eligiblityAcademicSchema
    .concat(eligibilityEnglishExamSchema)
    .concat(studentRegionSchema);
//# sourceMappingURL=eligibility.schema.js.map